import { useSnackbar } from './useSnackbar'

export const useToast = () => {
    const snackbar = useSnackbar()

    return {
        addToast: (message: string, type: 'success' | 'error' | 'info' | 'warning' = 'info') => {
            if (type === 'success') {
                return snackbar.showSuccess(message)
            } else if (type === 'error') {
                return snackbar.showError(message)
            } else if (type === 'warning') {
                return snackbar.showWarning(message)
            } else {
                return snackbar.showInfo(message)
            }
        }
    }
}